import Loading from 'flow/components/ui-components/Loading';

/* Covers the app while something the user cannot act on is in flight. */
const LoadingOverlay = () => {
    return (
        <div className="fixed inset-0 z-50 flex h-full w-full items-center justify-center bg-white/70">
            <Loading />
        </div>
    );
};

export default LoadingOverlay;
